import styled from 'styled-components'

export default styled.div`
  height: 90vh;
  overflow: auto;
  padding: 40px; 
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
`